import { FC, useCallback, useEffect } from 'react'

import { IColumn, Table } from '../../../core/components/Table'
import { useTableParams } from '../../../core/hooks/table-params'
import { Pagination } from '../Pagination'
import { PageTitle } from '@/components'

interface Props {
  clientId: string
}

export const ClientRunaHistoryTable: FC<Props> = ({ clientId }) => {
  const { page, setPage, size, setSize, sortBy, totalElements } =
    useTableParams({
      defaultSortBy: 'id',
    })

  const getData = useCallback(async () => {
    console.log('get data')
  }, [page, size, sortBy, clientId])

  useEffect(() => {
    getData()
  }, [clientId, getData])

  const changePage = async (newPage: number) => {
    setPage(newPage)
  }

  const columns: IColumn[] = [
    {
      title: 'RUNA',
      accessor: 'runa',
    },
    {
      title: 'Action',
      accessor: 'action',
    },
    {
      title: 'Created Date',
      accessor: 'createdDate',
    },
    {
      title: 'Order ID',
      accessor: 'orderId',
    },
    {
      title: 'Event ID',
      accessor: 'eventId',
    },
    {
      title: 'Target User ID',
      accessor: 'targetUserId',
    },
    {
      title: 'Payment',
      accessor: 'payment',
    },
    {
      title: 'View',
      accessor: 'view',
    },
  ]

  return (
    <>
      <PageTitle icon="document-text" title="RUNA History" className="mb-5" />
      <Table data={[]} columns={columns} />
      <Pagination
        className="static"
        size={size}
        totalElements={totalElements}
        setSize={setSize}
        page={page + 1}
        changePage={changePage}
        nested
      />
    </>
  )
}
